import { CONSTANT_KEYS, REPLACEMENTS_KEYS, RELATIONS_KEYS } from './tableKeys';

export const languageOption = ['ru', 'en'];
export const MAIN_PROFILE = 'main';
export const MEDEXP_RU = 'services_rus';
export const OVERTREATMENT_EN_TMP = 'overtreatment_en';
export const OVERTREATMENT_EN = 'services_ksa';
export const RELATIONS = {
  COMPLEX: 'complex',
  RELATED: 'related',
  MAPPED: 'mapped',
};

export const optionalServiceColumns = [
  CONSTANT_KEYS.COMMENT,
  CONSTANT_KEYS.WORDS,
  CONSTANT_KEYS.CODING,
  CONSTANT_KEYS.PROFILE,
  CONSTANT_KEYS.AGE,
  CONSTANT_KEYS.TEETH,
];

export const optionalDiagnosesColumns = [
  CONSTANT_KEYS.COMMENT,
  CONSTANT_KEYS.WORDS,
  CONSTANT_KEYS.CODING,
  CONSTANT_KEYS.PROFILE,
];

export const optionalReplacementsColumns = [
  REPLACEMENTS_KEYS.COMMENT,
  REPLACEMENTS_KEYS.REPLACEMENT_TYPE,
];

export const optionalRelatedCodeColumns = [
  RELATIONS_KEYS.CODING,
  RELATIONS_KEYS.NAME,
  RELATIONS_KEYS.COEFFICIENT,
  RELATIONS_KEYS.COMMENT,
  RELATIONS_KEYS.PROFILE,
];

export const ageOptions = ['all', 'child', 'adult'];

export const ENTIRE_ROW_MODE = {
  EQUAL: 'EQUAL',
  INCL: 'INCL',
};

export const entireRowModeOptions = [
  ENTIRE_ROW_MODE.EQUAL,
  ENTIRE_ROW_MODE.INCL,
];

export const STATUS_KEYS = {
  IDLE: 'idle',
  PENDING: 'pending',
  RESOLVED: 'resolved',
  REJECTED: 'rejected',
};

export const SOURCE = { TEXT: 'text', FILE: 'file' };

export const MATCH_SPECIFY = {
  GUARANTEE: 'guarantee',
  NPHIES: 'nphies',
  SERVICE: 'service',
};

export const MATCH_METHOD = {
  SAME: 'same',
  RELATED: 'related',
  WORDS: 'words',
};

export const processingFileResultStatus = {
  PENDING: 'PENDING',
  STARTED: 'STARTED',
  RETRY: 'RETRY',
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS',
};

export const CODING_GROUP = {
  SERVICES: 'services',
  DIAGNOSES: 'diagnoses',
  CATALOGS: 'catalogs',
  GENERAL: 'general',
};

export const ACTIVE_OPTIONS = [
  { label: 'YES', value: true },
  { label: 'NO', value: false },
];
